import * as S from "./styles";

type CardWitnessProps = {
  nome: string;
  cargo: string;
};
export const CardWitness = ({
  cargo,

  nome,
}: CardWitnessProps) => {
  return (
    <S.CardWitnessStyles>
      <p>
        Nome: <span>{nome}</span>
      </p>

      <p>
        Cargo: <span>{cargo}</span>
      </p>
    </S.CardWitnessStyles>
  );
};
